// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3kNX8","content":"LayoutSettings_content__3bWqy"};